import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    threshold1;
    threshold2;
    threshold3;
    isDistance;
    disabled;
    formData = {
        threshold1: this.$props.threshold1,
        threshold2: this.$props.threshold2,
        threshold3: this.$props.threshold3,
    };
    ruleRange1 = this.$props.isDistance ? '1-20' : '1-500';
    ruleRange2 = this.$props.isDistance ? '1-600' : '1-50';
    ruleRange3 = this.$props.isDistance ? '1-10' : '1-600';
    changeThreshold1(val) {
        this.$emit('update:threshold1', val);
    }
    changeThreshold2(val) {
        this.$emit('update:threshold2', val);
    }
    changeThreshold3(val) {
        this.$emit('update:threshold3', val);
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
    get rules() {
        return {
            threshold1: [
                { required: true, message: this.$t('inputRule') + this.ruleRange1, trigger: 'blur' },
                {
                    pattern: this.isDistance ? /^([1-9]|1\d|20)$/ : /^([1-9]|[1-9]\d|[1-4]\d\d|500)$/,
                    message: this.$t('inputRule') + this.ruleRange1,
                    trigger: 'blur',
                },
            ],
            threshold2: [
                { required: true, message: this.$t('inputRule') + this.ruleRange2, trigger: 'blur' },
                {
                    pattern: this.isDistance ? /^([1-9]|[1-9]\d|[1-5]\d\d|600)$/ : /^([1-9]|[1-4]\d|50)$/,
                    message: this.$t('inputRule') + this.ruleRange2,
                    trigger: 'blur',
                },
            ],
            threshold3: [
                { required: true, message: this.$t('inputRule') + this.ruleRange3, trigger: 'blur' },
                {
                    pattern: this.isDistance ? /^([1-9]|10)$/ : /^([1-9]|[1-9]\d|[1-5]\d\d|600)$/,
                    message: this.$t('inputRule') + this.ruleRange3,
                    trigger: 'blur',
                },
            ],
        };
    }
};
__decorate([
    Prop()
], default_1.prototype, "threshold1", void 0);
__decorate([
    Prop()
], default_1.prototype, "threshold2", void 0);
__decorate([
    Prop()
], default_1.prototype, "threshold3", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "isDistance", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
default_1 = __decorate([
    Component({
        name: 'FixedThreshold',
        components: {},
        i18n: {
            messages: {
                zh: {
                    threshold: '阈值',
                    meter: '米',
                    second: '秒',
                    gatherVisitor: '（聚集人数）',
                    gatherDistance: '（聚集距离）',
                    gatherTime: '（聚集时长）',
                    distanceVisitor: '（匹配人数）',
                    distanceTime: '（时长）',
                    distance: '（社交距离）',
                    inputRule: '请输入 ',
                },
                en: {
                    threshold: 'Threshold',
                    meter: 'Meters',
                    second: 'Seconds',
                    gatherVisitor: '(gather visitors)',
                    gatherDistance: '(distance)',
                    gatherTime: '(gather time)',
                    distanceVisitor: '(extremely close pairs)',
                    distanceTime: '(time)',
                    distance: '(social distance)',
                    inputRule: 'Please enter ',
                },
            },
        },
    })
], default_1);
export default default_1;
